var _g, _g2, _g3, _g4, _g5, _g6, _g7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeSaudeBeneficio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223,
    height: 79.384,
    viewBox: "0 0 223 79.384",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(53.116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M456.035,381.715l-9.676,9.73-26.723-26.853-3.909-3.928-4.577-4.606a19.3,19.3,0,0,1-.309-27.158,18.52,18.52,0,0,1,13.234-5.449,19.369,19.369,0,0,1,13.8,5.754l.9.906,3.764-4.066-.764-.761a24.809,24.809,0,0,0-17.7-7.379,23.983,23.983,0,0,0-17.136,7.068,24.874,24.874,0,0,0,.3,35.014l4.886,4.9,4,4.018,25.931,26.065.255.256c1,.892,2.574,2.061,4.019,2.061a5.494,5.494,0,0,0,3.888-1.881l.44-.436,8.905-8.956A27.2,27.2,0,0,1,456.035,381.715Z",
    transform: "translate(-399.883 -317.905)",
    fill: "#fff",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.323,324.973a23.994,23.994,0,0,0-17.136-7.068,24.809,24.809,0,0,0-17.7,7.379l-3.826,3.838-.688.767-6.614,6.8a2.773,2.773,0,0,0,1.975,4.716,2.74,2.74,0,0,0,1.975-.837l9.181-9.433.048-.069,1.851-1.86a19.358,19.358,0,0,1,13.8-5.754,18.538,18.538,0,0,1,18.637,18.022,26.487,26.487,0,0,1,5.457,2.677A24.373,24.373,0,0,0,452.323,324.973Z",
    fill: "#fff",
    transform: "translate(-366.427 -317.905)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.473 27.822)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.742,323.622a11.18,11.18,0,0,0-7.061,10.359,2.368,2.368,0,1,0,4.735,0,6.391,6.391,0,0,1,4.04-5.92,2.386,2.386,0,0,0,1.349-3.084A2.362,2.362,0,0,0,416.742,323.622Z",
    transform: "translate(-399.723 -312.868)",
    fill: "#f6d617"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.07,366.264l-6.215-8.084a20.96,20.96,0,1,0-14.624,5.982,20.826,20.826,0,0,0,10.192-2.663l6.277,8.16a2.76,2.76,0,0,0,2.188,1.079,2.712,2.712,0,0,0,1.686-.581A2.778,2.778,0,0,0,450.07,366.264Zm-36.316-23.216a15.485,15.485,0,1,1,15.478,15.56A15.537,15.537,0,0,1,413.754,343.048Z",
    transform: "translate(-408.234 -321.928)",
    fill: "#f6d617"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(32.659 47.287)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 17.311,
    transform: "translate(8.613)",
    fill: "#fff",
    stroke: "#f6d617",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 17.227,
    transform: "translate(17.227 8.655) rotate(90)",
    fill: "#fff",
    stroke: "#f6d617",
    strokeLinecap: "round",
    strokeWidth: 6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.254 15.551)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 17.311,
    transform: "translate(8.613)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 17.227,
    transform: "translate(17.227 8.655) rotate(90)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(181.958 47.287)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 17.311,
    transform: "translate(8.613)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 17.227,
    transform: "translate(17.227 8.655) rotate(90)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 6
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(202.773 19.879)"
  }, /*#__PURE__*/React.createElement("line", {
    y2: 17.311,
    transform: "translate(8.613)",
    fill: "#fff",
    stroke: "#f6d617",
    strokeLinecap: "round",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("line", {
    y2: 17.227,
    transform: "translate(17.227 8.655) rotate(90)",
    fill: "#fff",
    stroke: "#f6d617",
    strokeLinecap: "round",
    strokeWidth: 6
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(165.808 19.518)",
    fill: "#fff",
    stroke: "#f6d617",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.666,
    cy: 4.688,
    rx: 4.666,
    ry: 4.688,
    fill: "#fff",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 4.666,
    cy: 4.688,
    rx: 3.166,
    ry: 3.188,
    fill: "#fff",
    stroke: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 63.516)",
    stroke: "#fff",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.871,
    cy: 2.885,
    rx: 2.871,
    ry: 2.885,
    fill: "#fff",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.871,
    cy: 2.885,
    rx: 1.371,
    ry: 1.385,
    fill: "#fff",
    stroke: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeSaudeBeneficio);
export default __webpack_public_path__ + "static/media/icone-saude-beneficio.58293784a3150790f9ee35f7e56422ac.svg";
export { ForwardRef as ReactComponent };